module.exports = __webpack_public_path__ + "static/media/refresh.c99580c1.svg";